"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 32 32",
  width: 64,
  height: 64
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "A",
  d: "M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "B"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#A"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.727273 0 0 .727273 -.954545 -1.45455)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 37V11l17 13z",
  clipPath: "url(#B)",
  fill: "#fbbc05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 11l17 13 7-6.1L48 14V0H0z",
  clipPath: "url(#B)",
  fill: "#ea4335"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 37l30-23 7.9 1L48 0v48H0z",
  clipPath: "url(#B)",
  fill: "#34a853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48 48L17 24l-4-3 35-10z",
  clipPath: "url(#B)",
  fill: "#4285f4"
})));
var _default = exports.default = SvgComponent;